import { Component, inject, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { TRANSLATION_MAP } from '../../../const';
import { OnsiteCheckInClientAuthService } from '../../onsite-checkin-client/onsite-checkin-client-auth.service';
import { ElectronService } from '../../../../core/services';

@Component({
    selector: 'aoc-navbar-profile',
    templateUrl: './navbar-profile.component.html',
    styleUrls: ['./navbar-profile.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class NavbarProfileComponent {
    translations = TRANSLATION_MAP;
    authSvc = inject(OnsiteCheckInClientAuthService);
    private electronSvc = inject(ElectronService)
    user$ = this.authSvc.user$;

    constructor(private router: Router) {
    }

    async logout() {
        await this.authSvc.logout();
        this.authSvc.navigateToLogin();
    }
}
